import organisationUnits from "./organisation-locations";

export const ORGANISATION_LOCATIONS_NAMESPACE = `organisations/organisationLocations`;

export default organisationUnits;
